module.exports = __webpack_public_path__ + "img/silhouette-people-city.b203d2e1.jpg";